var map = {
	"./Author": 33,
	"./Author.js": 33,
	"./P": 34,
	"./P.js": 34,
	"./Post": 38,
	"./Post.js": 38,
	"./Tag": 39,
	"./Tag.js": 39
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;


//////////////////
// WEBPACK FOOTER
// ./src/contents ^\.\/.*$
// module id = 87
// module chunks = 0